import { Ticket } from "@/app/types/tickets";
import { displayValue, formatTime, getUserStatusColor, statusLabels } from "@/utils/Helper";
import { Badge } from "@/components/ui/Badge";
import { Ticket as TicketIcon } from "lucide-react";

interface TicketItemProps {
  ticket: Ticket;
  onClick?: () => void;
}

export const TicketItem = ({ticket, onClick}: TicketItemProps) =>  (
  <button
    key={ticket.id}
    className="p-4 bg-[#FDF8EE] rounded-xl border-2 border-primary flex flex-row sm:flex-row items-center justify-between w-full"
    onClick={onClick}
  >
    {/* Icon Column */}
    <div className="flex items-center justify-center p-2 bg-secondary border-2 rounded-full">
      <TicketIcon className="w-6 h-6 text-primary" />
    </div>

    {/* Ticket Info Column */}
    <div className="flex flex-col items-start">
      <div className="font-semibold md:text-base text-xs text-nowrap">
        Ticket No: {ticket.ticket_number}
      </div>

      <div className="text-[#B5A283] md:text-base text-xs text-nowrap">
        Counter No - {ticket.counter_id}
      </div>
      <div className="text-[#B5A283] md:text-base text-xs text-nowrap items-end flex ">
        {new Date(`${ticket.date ?? ""}`)
          .toLocaleDateString("en-PK", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-")
          }{" "}
        {displayValue(formatTime(ticket.time))}{" "}
      </div>
    </div>

    <div className="flex flex-col items-end justify-center">
      <Badge
        className={`capitalize ${getUserStatusColor(ticket.status)}  smm:!text-xs text-nowrap text-white`}
      >
        {statusLabels[ticket.status]}
      </Badge>
    </div>
  </button>
);
